import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";
import type { IUserSetPasswordDto } from "@api/users/setPassword/types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IUserSetPasswordDto
>("users.setPassword");

export const setPassword = {
  ...postApis,
};
